import { useHistory } from 'react-router-dom';
import { Box, Image } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import { RichText } from 'features/Bento/atoms';
import UnderReviewIllustration from 'features/Onboarding/images/underReview.svg';

import Layout from '../../Layout';
import locales from './locales';

const Success = () => {
  const history = useHistory();

  const onContinue = () => history.push('/');

  return (
    <Layout>
      <Box textAlign="center">
        <Image
          marginBottom="space-32"
          marginX="auto"
          src={UnderReviewIllustration}
        />

        <Heading size="lg">{locales.headline}</Heading>

        <RichText>{locales.description}</RichText>

        <Button marginTop="space-48" onClick={onContinue}>
          {locales.continue}
        </Button>
      </Box>
    </Layout>
  );
};

export default Success;
